module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE FOR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORN ON A")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTTEN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“"), _c('em', [_vm._v("Born On a Rotten Day")]), _vm._v(" delivers the dirt on every sign and then some! A fun, fast-paced, and frantically funny read.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Stuart Hazleton, author of "), _c('em', [_vm._v("Sexscopes")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A wry, clever look at the Darth Vader side of the zodiac.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Trish McGregor, author of "), _c('em', [_vm._v("Creative Stars: Using Astrology to Tap Your Muse")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“When you get to that place in your life when you’re ready to hear the truth about yourself, read this book and laugh.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Judith Turner, author of "), _c('em', [_vm._v("The Hidden World of Birthdays")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Hazel’s insightful zingers perfectly describe every person who has ever pissed me off.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Peter Bailey, webmaster/publisher of www.metamaze.com")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Hazel Dixon-Cooper has taken a perceptive, humorous look at the seamy underbelly of every sign. Her book is spot on for every sign … except for Sagittarius. We Sadges are perfect! Ha ha ha … ["), _c('em', [_vm._v("burp")]), _vm._v("]!”")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—Charlene Lichtenstein, author of "), _c('em', [_vm._v("Herscopes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e26bbbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0